import { render } from "./LinePayDialogFrame.vue?vue&type=template&id=a4228c28&scoped=true&ts=true"
import script from "./LinePayDialogFrame.vue?vue&type=script&lang=ts"
export * from "./LinePayDialogFrame.vue?vue&type=script&lang=ts"

import "./LinePayDialogFrame.vue?vue&type=style&index=0&id=a4228c28&scoped=true&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4228c28"]])

export default __exports__